import React from "react";
import { IconType } from "./types";

const Favorite: IconType = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 14"
    fill="#CCC"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M14.6268 7.6547C15.5409 6.77955 16 5.63168 16 4.48564C16 3.33777 15.5409 2.1899 14.6268 1.31474C13.8467 0.567064 12.8598 0.138374 11.8422 0.0288043C10.4752 -0.118412 9.05354 0.310279 8.00541 1.31474L7.99979 1.32008L7.99403 1.31474C7.08 0.439591 5.88113 0 4.68418 0C3.48531 0 2.28663 0.439591 1.37259 1.31474C-0.457531 3.06523 -0.457531 5.90422 1.37259 7.6547L7.99979 14L14.6268 7.6547Z"
      fill="inherit"
    />
  </svg>
);

export default Favorite;
